import { Badge } from "../components/ui/badge";

const MAP = {
  // Cobros
  Pagado: "bg-emerald-50 text-emerald-800 border-emerald-200",
  Pendiente: "bg-yellow-50 text-yellow-800 border-yellow-200",
  Atrasado: "bg-red-50 text-red-800 border-red-200",
  // Visitas
  Propuesta: "bg-yellow-50 text-yellow-800 border-yellow-200",
  Confirmada: "bg-emerald-50 text-emerald-800 border-emerald-200",
  Reprogramada: "bg-blue-50 text-blue-800 border-blue-200",
  Realizada: "bg-slate-100 text-slate-700 border-slate-200",
  // Contratos
  Vigente: "bg-emerald-50 text-emerald-800 border-emerald-200",
  "Por vencer": "bg-yellow-50 text-yellow-800 border-yellow-200",
  Vencido: "bg-red-50 text-red-800 border-red-200",
  // Reclamos
  Abierto: "bg-red-50 text-red-800 border-red-200",
  Asignado: "bg-blue-50 text-blue-800 border-blue-200",
  "En curso": "bg-yellow-50 text-yellow-800 border-yellow-200",
  Cerrado: "bg-slate-100 text-slate-700 border-slate-200",
  // Depósito
  Retenido: "bg-yellow-50 text-yellow-800 border-yellow-200",
  "A devolver": "bg-blue-50 text-blue-800 border-blue-200",
  Devuelto: "bg-emerald-50 text-emerald-800 border-emerald-200",
  // Contratos (salida / finalización)
  "En salida": "bg-blue-50 text-blue-800 border-blue-200",
  Finalizado: "bg-slate-100 text-slate-700 border-slate-200",
  // Arreglos
  Reportado: "bg-red-50 text-red-800 border-red-200",
  Presupuestado: "bg-yellow-50 text-yellow-800 border-yellow-200",
  Aprobado: "bg-blue-50 text-blue-800 border-blue-200",
  Terminado: "bg-emerald-50 text-emerald-800 border-emerald-200",
  Rechazado: "bg-red-50 text-red-800 border-red-200",
  // Inventario
  Bueno: "bg-emerald-50 text-emerald-800 border-emerald-200",
  Regular: "bg-yellow-50 text-yellow-800 border-yellow-200",
  Malo: "bg-red-50 text-red-800 border-red-200",
  // Prioridad de tareas
  Alta: "bg-red-50 text-red-800 border-red-200",
  Media: "bg-yellow-50 text-yellow-800 border-yellow-200",
  Baja: "bg-slate-100 text-slate-700 border-slate-200",
  // Situaciones de ejemplo
  "Recién firmado": "bg-blue-50 text-blue-800 border-blue-200",
  "Al día": "bg-emerald-50 text-emerald-800 border-emerald-200",
  "Con atraso": "bg-red-50 text-red-800 border-red-200",
  "Ajuste este mes": "bg-purple-50 text-purple-800 border-purple-200",
  "Arreglo en curso": "bg-yellow-50 text-yellow-800 border-yellow-200",
  // Leads
  Nuevo: "bg-blue-50 text-blue-800 border-blue-200",
  Contactado: "bg-yellow-50 text-yellow-800 border-yellow-200",
  "Visita agendada": "bg-purple-50 text-purple-800 border-purple-200",
  "En negociación": "bg-amber-50 text-amber-800 border-amber-200",
  // Ocupación
  Ocupado: "bg-amber-50 text-amber-800 border-amber-200",
  Libre: "bg-emerald-50 text-emerald-800 border-emerald-200",
  // Índices
  ICL: "bg-blue-50 text-blue-800 border-blue-200",
  IPC: "bg-purple-50 text-purple-800 border-purple-200",
  Fijo: "bg-slate-100 text-slate-700 border-slate-200",
};

export function StatusBadge({ estado, className = "", testId }) {
  const cls = MAP[estado] || "bg-slate-100 text-slate-700 border-slate-200";
  return (
    <Badge
      data-testid={testId}
      variant="outline"
      className={`${cls} rounded-md font-medium border ${className}`}
    >
      {estado}
    </Badge>
  );
}
